export default {
  layouts: {
    toogle_button: 'Toggle navigation',
    nav_bar_options: {
      account: 'My account',
      organization: 'My Organization',
      manageUsers: 'My Users',
      logout: 'Logout',
    },
    welcome_alert: {
      p1: 'CAT4MRO is now ACCUSELLER, Welcome ',
      p2: ' of the company',
    },
    footer: 'Unilink Solutions',
    portals: 'Portals',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/layouts.js